<template>
  <Loading v-if="isLoading" :loadingText="'Carregando...'"></Loading>
  <div v-else>
    <div class="main-superpro" v-if="temPermissao('p-super-admin')">
      <b-container fluid="xl" class="py-4">
        <b-card no-body header-bg-variant="white" class="shadow-sm">
          <template #header>
            <h4>Gerenciar Super Pro</h4>
          </template>
          <div class="d-flex align-items-center justify-content-baseline">
            <SuperProMenu />
          </div>
        </b-card>
  
        <b-card no-body class="p-3 mt-3 shadow-sm">
          <div v-if="!showContent">
            <h4 class="text-center">Por favor selecione um item do menu para gerenciar!</h4>
          </div>
          <div v-else>
            <router-view></router-view>
          </div>
        </b-card>
      </b-container>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/loading.vue';

export default {
  name: 'super-pro-menu',
  metaInfo: {
    title: 'Administração Super PRO',
  },
  components: {
    SuperProMenu: () => import('./superpro-menu.vue'),
    Loading
  },
  data() {
    return {
      variants: ['warning'],

      idEscolaSelecionada: null,
      nomeEscolaSelecionada: '',

      showContent: false,

      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Soluções',
          href: '/admin-super-pro',
        },

        {
          text: 'Super Pro',
          href: '/admin-super-pro',
          active: false,
        },
      ],

      searchNome: '',
      isLoading: true,
    };
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false
    }, 1000)
  },
  created() {
    const knownRoutes = ['users-superpro', 'schools-superpro', 'vincularUsuario'];
    this.showContent = knownRoutes.includes(this.$route.name);

  },
  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
  },
  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },
    closeContent() {
      this.$router.push({ name: 'adminSuperPro' });
    },
    navigateTo(routeName) {
      if (this.$route.path !== routeName) {
        this.$router.push({ name: routeName });
      } else {
        console.error('Estamos com problemas');
      }
    },
    showNavClick(section) {
      this.consulta = section === 'consultar';
      this.usuario = section === 'usuarios';
      this.escola = section === 'escolas';

      localStorage.setItem('activeSection', section);
    },
    handleEscolaSelecionada(idEscola, nomeEscola) {
      this.idEscolaSelecionada = idEscola;
      this.nomeEscolaSelecionada = nomeEscola;
    },
  },
  watch: {
    '$route'(to) {
      const knownRoutes = [
        'users-superpro',
        'schools-superpro',
        'vincularUsuario',
        'listaUsuarios',
        'criaUsuarioSuperPro',
        'editarUsuarioSuperPro',
        'cadastrarCreditoEscolaSuperPro',
        'consultarCreditoSuperPro',
        'estornarCreditoSuperPro',
        'excluiUsuarioSuperPro',
        'listaEscola',
        'cadastrarEscolaSuperPro',
        'estornarCreditoEscolaSuperPro',
      ]
      this.showContent = knownRoutes.includes(to.name)
    },
  },
};
</script>

<style scoped>
.fade-in-up {
  -webkit-animation: fadeIn 0.4s ease-in-out;
  -moz-animation: fadeIn 0.4s ease-in-out;
  -o-animation: fadeIn 0.4s ease-in-out;
  animation: fadeIn 0.4s ease-in-out;
}

/* .main-superpro {
  height: calc(100vh - 214px);
} */

.header__sistema {
  margin-top: -0px;
}

.bread_sistema {
  margin-top: -32px;
}

.btn__filters {
  padding: 0.5rem 1rem;
  border: 1px solid #f1f2f3;
  margin: 0 0.625rem 0 0;
  border-radius: 0.3125rem;
}

.btn__filters:hover {
  padding: 0.5rem 1rem;
  border: 1px solid #e3e5e78e;
  background: #e3e5e78e;
  transition: all 0.38s ease-in-out;
}

.btn__filters span {
  color: #333333;
}

.btn__filters.active {
  padding: 0.5rem 1rem;
  background: #e3e5e78e;
  border: 1px solid #e3e5e78e;
  border-radius: 0.3125rem;
}

.btn__filters.active span {
  color: #333333;
}

.card_sistemacpv {
  border-radius: 8px;
}
</style>
